export const FAQS = [
  {
    title: "What is the advantage of moving from EC2 to Zadara?",
    content:
      "Zadara offers predictable billing, full infrastructure control, and private resource isolation — ideal for enterprises needing regulatory compliance, storage flexibility, or hybrid cloud continuity.",
  },
  {
    title: "Will my application architecture need to change?",
    content:
      "In most cases, no. Zadara supports standard Linux/Windows instances, container workloads, and common protocols — allowing your apps to run with little or no modification.",
  },
  {
    title: "How does OneMind automate the migration from EC2?",
    content:
      "We use tools like Xmost Migrator, Terraform, and AWS APIs to replicate VM images, volumes, and configurations into Zadara compute/storage environments — reducing manual steps.",
  },
  {
    title: "Can we migrate EC2 auto-scaling groups or ASG workloads?",
    content:
      "Auto-scaling logic needs to be rebuilt using Zadara’s orchestration APIs or external schedulers (e.g., Kubernetes, Terraform) — OneMind helps with rearchitecting if needed.",
  },
  {
    title: "Is there support for migrating EC2 EBS volumes and snapshots?",
    content:
      "Yes. EBS data can be replicated into zStorage block volumes. We support snapshot transfers and also offer secure rsync and block-level sync options.",
  },
  {
    title: "How is network security handled post-migration?",
    content:
      "Zadara supports full L3 isolation, custom routing, firewall policies, and VPN integrations. OneMind maps existing AWS security groups into Zadara-equivalent access policies.",
  },
  {
    title: "What happens to our AWS billing or reserved instances?",
    content:
      "Reserved instances cannot be migrated. We help you phase them out strategically or reduce overlap during transition to avoid dual billing.",
  },
  {
    title: "Does Zadara support object storage like S3?",
    content:
      "Yes. Zadara offers S3-compatible object storage, allowing for seamless migration of buckets and application-level integrations using existing S3 APIs.",
  },
  {
    title: "How long will the migration take?",
    content:
      "Typical timelines range from 3–10 business days depending on instance count, data size, and complexity. We offer phased cutovers for live environments.",
  },
  {
    title: "Will OneMind manage the environment post-migration?",
    content:
      "Yes. We offer fully managed services including monitoring, patching, security policy enforcement, backup configuration, and resource scaling — under a single SLA.",
  },
];
